import(/* webpackMode: "eager" */ "/vercel/path0/apps/curated-website/src/app/profile/[walletOrUsername]/layout.tsx");
